<template>
  <v-dialog
    v-model="show"
    :width="categories.length>1 ? '50%' : 600"
    overlay-color="darktext"
    overlay-opacity="0.6"
    :persistent="loading ? true : false"
    disabled
    scrollable
  >
    <v-card class="pa-5" color="greyactivitybackground">
      <AlertMessages
        v-if="alertValue"
        :alert-type="alertType"
        :alert-msg="alertMsg"
        @reset="alertValue = false"
      />
      <v-row no-gutters class="">
        <v-col cols="11">
          <v-card-title
            class="no-break text-h5 mb-1 font-weight-bold"
          >
            {{ cdTitle }}
          </v-card-title>
          <v-card-subtitle>
            {{ cdDescription }}
          </v-card-subtitle>
        </v-col>
        <v-col cols="1" class="justify-end d-flex" style="height:24px">
          <v-icon
            ref="cancel"
            data-testid="cancel-button"
            min-width="100"
            class="rounded-xxl text-none my-0"
            @click="closeDialog"
          >
            mdi-close
          </v-icon>
        </v-col>
         <div v-if="!alertMsgSuccessValue" class="mr-5 px-6" style="position:absolute; top:70px; right:0px">
            <span
            style="color: var(--v-success-base)" class="text-caption">{{ alertMsgSuccess }}</span> 
          </div>
      </v-row>
      <v-card-text class="px-5">
      <draggable 
        v-if="categories.length > 1"
        :list="categories"
        :disabled="!enabled"
        class="grid-group row mx-auto pt-4"
        ghost-class="grid-ghost"
        @start="dragging = true"
        @end="endCategories"
        data-testid="grid-categories"
      >
        <v-col cols="3"
          class="grid-group-item pa-1"
          v-for="item in categories"
          :key="item.id"
        >
           <v-card class="py-3 px-3" rounded="lg" :color="item.attributes.bg_color">
            <v-row no-gutters>
              <v-col cols="11" class="text-left">
                 <v-clamp
                    autoresize
                    :max-lines="1"
                    class="darktext--text"
                  >
                    {{ item.attributes.title }}
                  </v-clamp>
              </v-col>
              <v-col cols="1" class="justify-center d-flex">
                <v-icon class="">
                  mdi-drag-vertical
                </v-icon>
              </v-col>
            </v-row>
          </v-card>
         </v-col>
      </draggable>
      <v-divider class="my-5" v-if="categories.length > 1 && hubItems.length > 1"/>
      <draggable
        v-if="hubItems.length > 1"
        :list="hubItems"
        :disabled="!enabled"
        ghost-class="list-ghost"
        @start="dragging = true"
        @end="endHubItems"
        data-testid="list-hubitems"
      >
        <div
          class="list-group-item py-1"
          v-for="item in hubItems"
          :key="item.id"
        >
          <v-card class="py-3 px-3" rounded="lg" >
          <v-row no-gutters>
            <v-col cols="11" class="text-left">
                  <span
                    v-if="
                      item.attributes.entity_type == 'hub_attachments' &&
                      attachmentIcons[
                        attachmentIcons.findIndex(
                          (itemIcon) =>
                            itemIcon.type ==
                            item.attributes.attachment_ext
                        )
                      ]
                    "
                    :style="
                      `color: ` +
                      attachmentIcons[
                        attachmentIcons.findIndex(
                          (itemIcon) =>
                            itemIcon.type ==
                            item.attributes.attachment_ext
                        )
                      ].color
                    "
                    :class="
                      `mdi mdi-24px ` +
                      attachmentIcons[
                        attachmentIcons.findIndex(
                          (itemIcon) =>
                            itemIcon.type ==
                            item.attributes.attachment_ext
                        )
                      ].icon
                    "
                    style="float: left"
                    >&nbsp;</span
                  >
                  <span
                    v-if="item.attributes.entity_type == 'hub_links'"
                    class="mdi mdi-24px mdi-web accent--text"
                    style="float: left"
                    >&nbsp;</span
                  >
                  <v-clamp autoresize :max-lines="1">
                    {{ item.attributes.title }}
                  </v-clamp>
            </v-col>
            <v-col cols="1" class="justify-end d-flex">
              <v-icon class="mr-n1">
                mdi-drag-vertical
              </v-icon>
            </v-col>
            </v-row>
          </v-card>
        </div>
      </draggable>
      <draggable
        v-else
        :list="itemsInCategory"
        :disabled="!enabled"
        ghost-class="list-ghost"
        @start="dragging = true"
        @end="endItemsInCategory"
        data-testid="list-items-in-category"
      >
        <div
          class="list-group-item py-1"
          v-for="item in itemsInCategory"
          :key="item.id"
        >
           <v-card class="py-3 px-3" rounded="lg">
            <v-row no-gutters>
              <v-col cols="11" class="text-left">
                    <span
                    v-if="
                      item.attributes.entity_type == 'hub_attachments' &&
                      attachmentIcons[
                        attachmentIcons.findIndex(
                          (itemIcon) =>
                            itemIcon.type ==
                            item.attributes.attachment_ext
                        )
                      ]
                    "
                    :style="
                      `color: ` +
                      attachmentIcons[
                        attachmentIcons.findIndex(
                          (itemIcon) =>
                            itemIcon.type ==
                            item.attributes.attachment_ext
                        )
                      ].color
                    "
                    :class="
                      `mdi mdi-24px ` +
                      attachmentIcons[
                        attachmentIcons.findIndex(
                          (itemIcon) =>
                            itemIcon.type ==
                            item.attributes.attachment_ext
                        )
                      ].icon
                    "
                    style="float: left"
                    >&nbsp;</span
                  >
                  <span
                    v-if="item.attributes.entity_type == 'hub_links'"
                    class="mdi mdi-24px mdi-web accent--text"
                    style="float: left"
                    >&nbsp;</span
                  >
                  <v-clamp autoresize :max-lines="1">
                    {{ item.attributes.title }}
                  </v-clamp>
              </v-col>
              <v-col cols="1" class="justify-end d-flex" >
                <v-icon class="mr-n1">
                  mdi-drag-vertical
                </v-icon>
              </v-col>
            </v-row>
          </v-card>
        </div>
      </draggable>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from '../plugins/i18n';
import draggable from "vuedraggable";
import AlertMessages from "./AlertMessages";
import VClamp from "vue-clamp";
import { reorderCategories,reorderHubItemsWithoutCategory,reorderItemsInCategory} from "../api/hubApi";
export default {
   components: {
        draggable,
        AlertMessages,
        VClamp
    },
  props: {
    visible: Boolean,
    cdTitle: {
      type: String,
      default: ''
    },
    cdDescription:{
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    },
    itemsCategories: {
      type: Array,
      default: () => []
    },
    items: {
      type: Array,
      default: () => []
    },
    itemsCategory: {
      type: Array,
      default: () => []
    }
  },
  data(){
      return{
        valid: true,
        alertMsg: "",
        alertType: "",
        alertValue: false,
        categories: [],
        hubItems:[],
        itemsInCategory:[],
        enabled: true,
        dragging: false,
        hubID: this.$route.params.id,
        categoryId: this.$route.params.categoryId,
        listHubItems:[],
        listCategories:[],
        listAllItemsInCategory:[],
        attachmentIcons: [
        {
          background: "#C9F3DB",
          type: "jpeg",
          color: "#00C853",
          icon: "mdi-file-jpg-box",
        },
        {
          background: "#C9F3DB",
          type: "jpg",
          color: "#00C853",
          icon: "mdi-file-jpg-box",
        },
        {
          background: "#D2DEFD",
          type: "png",
          color: "#2962FF",
          icon: "mdi-file-png-box",
        },
        {
          background: "#FFCED7",
          type: "pdf",
          color: "#ff1744",
          icon: "mdi-file-pdf-box",
        },
        {
          background: "#FEF2D3",
          type: "ppt",
          color: "#FBC02D",
          icon: "mdi-file-powerpoint-outline",
        },
        {
          background: "#FEF2D3",
          type: "pptx",
          color: "#FBC02D",
          icon: "mdi-file-powerpoint-outline",
        },
        {
          background: "#D2DEFD",
          type: "doc",
          color: "#2979FF",
          icon: "mdi-file-document-outline",
        },
        {
          background: "#D2DEFD",
          type: "docx",
          color: "#2979FF",
          icon: "mdi-file-document-outline",
        },
        {
          background: "#C9F3DB",
          type: "xls",
          color: "#00C853",
          icon: "mdi-file-excel-outline",
        },
        {
          background: "#C9F3DB",
          type: "xlsx",
          color: "#00C853",
          icon: "mdi-file-excel-outline",
        },
        {
          background: "#D2DEFD",
          type: "odt",
          color: "#2979FF",
          icon: "mdi-file-document-outline",
        },
        {
          background: "#C9F3DB",
          type: "csv",
          color: "#00C853",
          icon: "mdi-file-delimited-outline",
        },
        {
          background: "#C9F3DB",
          type: "ods",
          color: "#00C853",
          icon: "mdi-file-excel-outline",
        },
        {
          background: "#E3E3E3",
          type: "rtf",
          color: "#7C8386",
          icon: "mdi-file-document-outline",
        },
        {
          background: "#E3E3E3",
          type: "txt",
          color: "#7C8386",
          icon: "mdi-file-document-outline",
        },
      ],
      alertMsgSuccess:"",
      alertMsgSuccessValue:false
      }
    },    
    computed: {
        show: {
            get () {
                return this.visible
            },
            set (value) {
                if (!value) {
                    this.$emit('close')
                }
            }
        }
    },
     async   created(){
      this.categories = JSON.parse(JSON.stringify(this.itemsCategories))
       this.hubItems = JSON.parse(JSON.stringify(this.items))
       this.itemsInCategory = JSON.parse(JSON.stringify(this.itemsCategory))
    },
    methods: {
    async reorderCategories(){
      let count = this.categories.length
      this.listCategories = [];
      let position = count;


      for (let i = 0; i < this.categories.length; i++) {
        this.listCategories.push({
          id: this.categories[i].id,
          position: position--,
        });
      }
        try {
          let data = {
            data: {
              type: "hubs",
              attributes: {
                hub_feed_items: this.listCategories,
              }
              
            },
          };
          const response = await reorderCategories(this.hubID, data);
          if (response) {
            if (response.status == 200) {
              this.alertMsgSuccess  = i18n.t("reorderSuccessMsg");
              setTimeout(() => {
                  this.alertMsgSuccessValue = true
              },2000);
              this.$emit('proceedSubmit')
            }
          }
        } catch (e) {
          if (e.response) {
            this.alertValue = true
            this.alertType = 'error'
              if (e.response.status == 422 ){
                  for(let i = 0; i < e.response.data.errors.length; i++){
                      if(e.response.data.errors[i].meta[0].code == 'hubFeedItemsIncompatibillity'){
                          this.alertMsg =  i18n.t('hubFeedItemsIncompatibillityError')
                      }else {
                          this.alertMsg = i18n.t('serverError')
                      }
                  }
              }else if (e.response.status == 403){
                this.$router.push({name: 'PageAccessDenied'})
              }else if(e.response.status == 404) {
                this.$router.push({name: 'PageNotFound'})
              } else {
                this.alertMsg =  i18n.t('serverError')       
              } 
          } else {
            this.alertValue = true
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }

        
    },
    async reorderHubItemsWithoutCategory(){
      this.listHubItems = [];
      let position = this.hubItems.length;
      for (let i = 0; i < this.hubItems.length; i++) {
        this.listHubItems.push({
          id: this.hubItems[i].id,
          position: position--,
        });
      }
        try {
          let data = {
            data: {
              type: "hubs",
              attributes: {
                hub_feed_items: this.listHubItems,
              }
              
            },
          };
          const response = await reorderHubItemsWithoutCategory(this.hubID, data);
          if (response) {
            if (response.status == 200) {
              this.alertMsgSuccess  = i18n.t("reorderSuccessMsg");
              setTimeout(() => {
                  this.alertMsgSuccessValue = true
              },2000);
              this.$emit('proceedSubmit')
            }
          }
        } catch (e) {
          if (e.response) {
              this.alertValue = true
              this.alertType = 'error'
                if (e.response.status == 422 ){
                    for(let i = 0; i < e.response.data.errors.length; i++){
                        if(e.response.data.errors[i].meta[0].code == 'hubFeedItemsIncompatibillity'){
                            this.alertMsg =  i18n.t('hubFeedItemsIncompatibillityError')
                        }else {
                            this.alertMsg = i18n.t('serverError')
                        }
                    }
                }else if (e.response.status == 403){
                  this.$router.push({name: 'PageAccessDenied'})
                }else if(e.response.status == 404) {
                  this.$router.push({name: 'PageNotFound'})
                } else {
                  this.alertMsg =  i18n.t('serverError')       
                } 
          }
           else {
            this.alertValue = true
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }      
    },
    async reorderItemsInCategory(){

      let count = this.itemsInCategory.length
      this.listAllItemsInCategory = [];
      let position = count;
      for (let i = 0; i < this.itemsInCategory.length; i++) {
        this.listAllItemsInCategory.push({
          id: this.itemsInCategory[i].id,
          position: position--,
        });
      }
        try {
          let data = {
            data: {
              type: "hubs",
              attributes: {
                hub_feed_items: this.listAllItemsInCategory,
              }
              
            },
          };
          const response = await reorderItemsInCategory(this.hubID,this.categoryId, data);
          if (response) {
            if (response.status == 200) {
              this.alertMsgSuccess  = i18n.t("reorderSuccessMsg");
              setTimeout(() => {
                  this.alertMsgSuccessValue = false
              }, 2000);
              this.$emit('proceedSubmit')
            }
          }
        } catch (e) {
          if (e.response) {
              this.alertValue = true
              this.alertType = 'error'
                if (e.response.status == 422 ){
                    for(let i = 0; i < e.response.data.errors.length; i++){
                        if(e.response.data.errors[i].meta[0].code == 'hubFeedItemsIncompatibillity'){
                            this.alertMsg =  i18n.t('hubFeedItemsIncompatibillityError')
                        }else {
                            this.alertMsg = i18n.t('serverError')
                        }
                    }
                }else if (e.response.status == 403){
                  this.$router.push({name: 'PageAccessDenied'})
                }else if(e.response.status == 404) {
                  this.$router.push({name: 'PageNotFound'})
                } else {
                  this.alertMsg =  i18n.t('serverError')       
                } 
          }
           else {
            this.alertValue = true
            this.alertType = "error";
            this.alertMsg = i18n.t("serverError");
          }
        }
      },
      async endCategories(){
        this.alertMsgSuccessValue = false
        await this.reorderCategories();
      },
      async endHubItems(){
        this.alertMsgSuccessValue = false
        await this.reorderHubItemsWithoutCategory();
      },
      async endItemsInCategory(){
        this.alertMsgSuccessValue = false
        await this.reorderItemsInCategory();
      },
      closeDialog() {
      if (!this.loading) {
        this.$emit("close");
      }
    },
  },
}
</script>